/**
 * SEO Testing Utilities für Custom Domains
 * Kann in Browser Console verwendet werden
 */

// Test Functions für Browser Console
window.testCustomDomainSEO = {
  
  /**
   * Test Meta-Tags der aktuellen Page
   */
  testMetaTags: () => {
    console.log('🔍 Testing Meta Tags:');
    
    const title = document.title;
    const description = document.querySelector('meta[name="description"]')?.content;
    const ogTitle = document.querySelector('meta[property="og:title"]')?.content;
    const ogDescription = document.querySelector('meta[property="og:description"]')?.content;
    const ogImage = document.querySelector('meta[property="og:image"]')?.content;
    const ogSiteName = document.querySelector('meta[property="og:site_name"]')?.content;
    const favicon = document.querySelector('link[rel="icon"]')?.href;
    const canonical = document.querySelector('link[rel="canonical"]')?.href;
    
    console.log('📄 Page Meta-Tags:');
    console.log('Title:', title);
    console.log('Description:', description);
    console.log('Canonical:', canonical);
    
    console.log('📱 Open Graph:');
    console.log('OG Title:', ogTitle);
    console.log('OG Description:', ogDescription);
    console.log('OG Image:', ogImage);
    console.log('OG Site Name:', ogSiteName);
    
    console.log('🎨 Branding:');
    console.log('Favicon:', favicon);
    
    // Check for BonusClub references
    const hasBonusClubRef = [title, description, ogTitle, ogDescription, ogSiteName]
      .some(text => text && text.toLowerCase().includes('bonusclub'));
    
    console.log(hasBonusClubRef ? '❌ BonusClub references found!' : '✅ No BonusClub references');
    
    return {
      title, description, ogTitle, ogDescription, ogImage, ogSiteName, favicon, canonical,
      hasBonusClubRef
    };
  },
  
  /**
   * Test robots.txt
   */
  testRobotsTxt: async () => {
    console.log('🤖 Testing robots.txt:');
    
    try {
      const response = await fetch('/robots.txt');
      const text = await response.text();
      
      console.log('Status:', response.status);
      console.log('Content-Type:', response.headers.get('content-type'));
      console.log('Content:');
      console.log(text);
      
      return { status: response.status, content: text };
    } catch (error) {
      console.error('❌ Error fetching robots.txt:', error);
      return { error: error.message };
    }
  },
  
  /**
   * Test sitemap.xml
   */
  testSitemap: async () => {
    console.log('🗺️ Testing sitemap.xml:');
    
    try {
      const response = await fetch('/sitemap.xml');
      const text = await response.text();
      
      console.log('Status:', response.status);
      console.log('Content-Type:', response.headers.get('content-type'));
      console.log('Content:');
      console.log(text);
      
      // Parse XML to count URLs
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(text, 'text/xml');
      const urls = xmlDoc.querySelectorAll('url');
      console.log(`📊 Found ${urls.length} URLs in sitemap`);
      
      return { status: response.status, content: text, urlCount: urls.length };
    } catch (error) {
      console.error('❌ Error fetching sitemap.xml:', error);
      return { error: error.message };
    }
  },
  
  /**
   * Test PWA manifest
   */
  testManifest: async () => {
    console.log('📱 Testing manifest.webmanifest:');
    
    try {
      const response = await fetch('/manifest.webmanifest');
      const manifest = await response.json();
      
      console.log('Status:', response.status);
      console.log('Content-Type:', response.headers.get('content-type'));
      console.log('Manifest:', manifest);
      
      return { status: response.status, manifest };
    } catch (error) {
      console.error('❌ Error fetching manifest:', error);
      return { error: error.message };
    }
  },
  
  /**
   * Test Social Media Previews
   */
  testSocialPreviews: () => {
    console.log('📱 Testing Social Media Previews:');
    
    const currentUrl = window.location.href;
    
    const facebookDebugger = `https://developers.facebook.com/tools/debug/?q=${encodeURIComponent(currentUrl)}`;
    const twitterValidator = `https://cards-dev.twitter.com/validator?url=${encodeURIComponent(currentUrl)}`;
    const linkedinInspector = `https://www.linkedin.com/post-inspector/inspect/${encodeURIComponent(currentUrl)}`;
    
    console.log('🔗 Test your social previews:');
    console.log('Facebook Debugger:', facebookDebugger);
    console.log('Twitter Card Validator:', twitterValidator);
    console.log('LinkedIn Post Inspector:', linkedinInspector);
    
    // Open all in new tabs
    window.open(facebookDebugger, '_blank');
    window.open(twitterValidator, '_blank');
    window.open(linkedinInspector, '_blank');
    
    return { facebookDebugger, twitterValidator, linkedinInspector };
  },
  
  /**
   * Complete SEO Audit
   */
  runCompleteAudit: async () => {
    console.log('🔍 Running Complete SEO Audit...');
    
    const metaTags = window.testCustomDomainSEO.testMetaTags();
    const robots = await window.testCustomDomainSEO.testRobotsTxt();
    const sitemap = await window.testCustomDomainSEO.testSitemap();
    const manifest = await window.testCustomDomainSEO.testManifest();
    
    console.log('📊 SEO Audit Complete:');
    console.log('Meta Tags:', metaTags.hasBonusClubRef ? '❌ Has BonusClub refs' : '✅ Clean');
    console.log('robots.txt:', robots.status === 200 ? '✅ OK' : '❌ Error');
    console.log('sitemap.xml:', sitemap.status === 200 ? `✅ OK (${sitemap.urlCount} URLs)` : '❌ Error');
    console.log('manifest:', manifest.status === 200 ? '✅ OK' : '❌ Error');
    
    return { metaTags, robots, sitemap, manifest };
  }
};

